const ipV4Address = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const localDevelopmentPort = '8090';
const permittedHosts = ['teonistor.github.io', 'teonistor.herokuapp.com', 'teodor.nistor.uk',
  'ro.teodor.nistor.uk'];

import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import router from './plugins/router';
import vuetify from './plugins/vuetify';

/* In order to run on two domains (which may be two ports) you need:
 * - Fully qualified API URLs
 * - To use an AxiosHelper with credential forwarding for authenticated calls (AxiosHelper.js)
 * - Allow credentials and cross-origin calls in the backend for the frontend domain (WebSecurityConfig.java)
 * - N.b. devServer proxying (vue.config.js) has been abandoned, and it wasn't handling non-GET requests anyway
 */

if (location.hostname === 'localhost') {
  console.log('Superseding absolute path to backend because running on localhost');
  Vue.prototype.$backendRoot = 'http://localhost:' + localDevelopmentPort;

} else if (ipV4Address.test(location.hostname)) {
  console.log('Superseding absolute path to backend due to access by IP address');
  Vue.prototype.$backendRoot = 'http://' + location.hostname + ':' + localDevelopmentPort;

} else if (location.hostname.indexOf('herokuapp.com') >= 0) {
  Vue.prototype.$backendRoot = '';

} else {
  Vue.prototype.$backendRoot = 'https://teonistor.herokuapp.com';

}

Vue.prototype.$localDevelopmentPort = localDevelopmentPort
Vue.prototype.$interpretedHost = permittedHosts.includes(location.host) ? location.host : permittedHosts[0] + ' (on ' + location.host + ')';
// Vue.prototype.$isRo = location.host === 'ro.teodor.nistor.uk' || location.hostname === 'localhost';

/* API centralisation
 * - apiUrl - calls to the real backend
 * - dataUrl - static data stored in S3 (easily updatable but not browsable)
 * External APIs
 * - githubApiUrl
 */
Vue.prototype.$apiUrl = Vue.prototype.$backendRoot + '/api';
// Vue.prototype.$dataUrl = 'http://localhost:8101/data';
Vue.prototype.$dataUrl = 'https://teonistor-herokuapp-prod.s3.eu-west-2.amazonaws.com/data';
Vue.prototype.$githubApiUrl = 'https://api.github.com'

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
